// extracted by mini-css-extract-plugin
module.exports = {"checkboxGroup":"jut__CheckboxGroupField__checkboxGroup","tooltip":"jut__CheckboxGroupField__tooltip"};